/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import React from 'react';

import { propTypesUTMs } from '../../../../shared/constants/Proptypes';
import { propTypesSliceHomepageWebType } from './SliceZoneHomepageWeb.proptypes';

import { BigCtaSlice } from '../../../../shared/components/Slices/BigCta';
import { HeaderHomepageSlice } from '../../../../shared/components/Slices/HeaderHomepage';
import { HorizontalCardCtaSlice } from '../../../../shared/components/Slices/HorizontalCardCta';
import { InteractiveHorizontalSlice } from '../../../../shared/components/Slices/InteractiveHorizontal';
import { InteractiveVerticalSlice } from '../../../../shared/components/Slices/InteractiveVertical';
import { QuestionsTypeSlice } from '../../../../shared/components/Slices/QuestionsType';
import { SocialProofSlice } from '../../../../shared/components/Slices/SocialProof';
import { TestimonialCarouselSlice } from '../../../../shared/components/Slices/TestimonialCarousel';
import { WordCloudSlice } from '../../../../shared/components/Slices/WordCloud';

import { DocumentType } from '../../../../shared/constants/Enums';

// We import each dedicated slice component and then
// iterate over each slice to render the correct one
// https://prismic.io/docs/technologies/template-slices-gatsby
export const SliceZoneHomepageWeb = ({ slices, utms }) => {
  if (!slices) {
    return null;
  }

  const sliceComponents = {
    big_cta_homepage: BigCtaSlice,
    header_homepage: HeaderHomepageSlice,
    interactive_horizontal: InteractiveHorizontalSlice,
    interactive_vertical: InteractiveVerticalSlice,
    horizontal_card_cta: HorizontalCardCtaSlice,
    questions_type: QuestionsTypeSlice,
    social_proof: SocialProofSlice,
    testimonial_carousel: TestimonialCarouselSlice,
    wordcloud: WordCloudSlice,
  };

  return slices.map((slice, index) => {
    const SliceComponent = sliceComponents[slice.slice_type];

    if (SliceComponent) {
      return (
        <SliceComponent
          utms={utms}
          documentType={DocumentType.HOMEPAGEWEB}
          key={`${slice}-${index}`}
          slice={slice}
        />
      );
    }
    return null;
  });
};

SliceZoneHomepageWeb.propTypes = {
  /**
   * Slice list used in a Page.
   */
  slices: PropTypes.shape(propTypesSliceHomepageWebType),
  /**
   * Optional UTMs.
   */
  utms: PropTypes.shape(propTypesUTMs),
};
